export default __webpack_public_path__ + "static/media/comment.bc468619.png";